var exports = {
  "k": "xfd349460--9c76ac--container",
  "K": "xfd349460--9c76ac--icon",
};

module.exports = exports;
